export const handleLocationError = (browserHasGeolocation: boolean) => {
  alert(
    browserHasGeolocation
      ? 'กรุณาเปิดบริการหาตำแหน่งที่ตั้ง'
      : "Your browser doesn't support geolocation."
  );
};

export const getDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) => {
  const distX = (lon1 - lon2) * (lon1 - lon2);
  const distY = (lat1 - lat2) * (lat1 - lat2);

  return Math.abs(Math.sqrt(distX + distY));
};

export const googleMapURL = (params: {
  lat: string;
  lng: string;
  name?: string;
  url?: string;
}) => {
  if (params.url) {
    return params.url;
  }
  return `https://www.google.com/maps/search/${params.name}/${params.lat},${params.lng}`;
};

const toRadians = (degrees: number) => {
  return degrees * (Math.PI / 180);
};

export const calculateDistance = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) => {
  const earthRadius = 6371; // Radius of the Earth in kilometers
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = earthRadius * c;

  return distance;
};

export const getCurrentPosition = (
  success: (position: { lat: number; lng: number }) => void,
  error: () => void
) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position: GeolocationPosition) => {
        success({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      () => {
        error();
        handleLocationError(true);
      }
    );
  } else {
    error();
    handleLocationError(false);
  }
};
